import { useOutletContext } from 'react-router-dom'
import { type FeriadosCliente } from 'service/api'

export function useFeriadosClienteOutletContext() {
    return useOutletContext<{ data?: FeriadosCliente[] }>()
}
